import moment from 'moment';
import orderBy from 'lodash/orderBy';

import { mapBuilder } from 'src/common/helpers/common.helpers';

import { IActiveViewRange, IViewRange } from './gantt.interfaces';

export const getDateRange = ({ date = new Date(), type, increment }: IViewRange) => ({
  startDate: moment(date).add(increment, type).startOf(type).toDate(),
  endDate: moment(date).add(increment, type).endOf(type).toDate(),
});

export const buildViewRange = (props: IViewRange = {}): IActiveViewRange => {
  const { t = (v: string) => v, date = new Date(), type = 'month', increment = 0 } = props;
  const isMonthType = type === 'month';
  const range = getDateRange({ date, type, increment });
  const dateTitle = moment(range.startDate)
    .locale(props.i18n.language)
    .format(isMonthType ? 'MMMM YYYY' : 'YYYY');

  return {
    type,
    dateTitle: isMonthType ? dateTitle : `${t('gantt:labels.year')} ${dateTitle}`,
    ...range,
  };
};

export const getSortedEmployees = (employees: any[], employeeGanttOrderIds: any[] = []) => {
  // in case when sort is not exists return ordered employees by createdAt

  if (!employeeGanttOrderIds.length) return orderBy(employees, 'createdAt');

  const newEmployeesOrder: any = [];
  const employeesMap = mapBuilder(employees);

  employeeGanttOrderIds.forEach((employeeId: string) => {
    const employee = employeesMap[employeeId];

    if (employee) {
      newEmployeesOrder.push(employee);

      // removing from employeesMap sorted employee, after we will sort unused employees
      delete employeesMap[employeeId];
    }
  });

  const unsortedEmployees = Object.values(employeesMap);
  const sortedNotOrderedEmployees = orderBy(unsortedEmployees, 'createdAt');

  return [...newEmployeesOrder, ...sortedNotOrderedEmployees];
};
